import BundleInfoNavigatorT from '@factories/RowFactory/components/BundleInfoNavigator/types';
import { StyledBundleInfoNavigator } from '@factories/RowFactory/components/BundleInfoNavigator/styled/StyledBundleInfoNavigator';
import Image from 'next/image';
import { renderParagraphs } from '@lib/utils';
import React, { useState } from 'react';
import { SimpleFAQ } from '@components/Organisms/SimpleFAQs/SimpleFAQ';

export const BundleInfoNavigator = ({ title, display, items }: BundleInfoNavigatorT) => {
  const [activeFAQ, setActiveFAQ] = useState<number | null>(null);

  if (!display) return null;

  return (
    <StyledBundleInfoNavigator className="container">
      <h2>{title}</h2>
      <div className="circle-items-container">
        {items.map((item, index) => (
          <a key={`circle-item-${index}`} href={`#section-${index}`} className="circle">
            <span className="circle-text">{item.circleText}</span>
          </a>
        ))}
      </div>
      <div className="info-items-container">
        {items.map((item, index) => (
          <div key={`info-item-${index}`} className="info-item" id={`section-${index}`}>
            <div className="info">
              <h3>{item.title}</h3>
              {item.subtitle && <h4>{item.subtitle}</h4>}
              {renderParagraphs({ body: item.description, hasMarkdown: true })}
              <div className="faqs-container">
                {item.faqs.map((faq, faqIndex) => {
                  const faqNumber = Number(String(index) + String(faqIndex));
                  return (
                    <SimpleFAQ
                      key={`simple-faq-${faqNumber}`}
                      index={faqNumber}
                      faq={faq}
                      isActive={activeFAQ === faqNumber}
                      onClick={() => setActiveFAQ(activeFAQ === faqNumber ? null : faqNumber)}
                    />
                  );
                })}
              </div>
            </div>
            <div className="image">
              <Image
                src={item.image.url as string}
                alt={item.image.alternativeText}
                width={item.image.width}
                height={item.image.height}
                objectFit="cover"
              />
            </div>
          </div>
        ))}
      </div>
    </StyledBundleInfoNavigator>
  );
};
